<div class="container {{ 'size-' + size }}">
  <img [src]="src" (error)="this.Utils.manageErrorImage($event)" />
</div>
